
import { Vue, Component, Prop } from 'vue-property-decorator'
import AdManageApi from '@/apis/advertManage/admanage';
import samllProgram from "@/views/KtpActivity/ad/smallProgram.vue";
import {isWechat} from '@/utils/common';
import { Toast } from 'vant';
import Swiper from "swiper";
import SwiperCore, { Autoplay, FreeMode, Scrollbar, Mousewheel, Pagination } from "swiper";
SwiperCore.use([Autoplay, FreeMode, Scrollbar, Mousewheel, Pagination]);

//正在学习的课程
@Component({
  name: 'RecommendAdvertList',
  components: {
    samllProgram
  },
  props: {

  }
})
export default class RecommendAdvertList extends Vue {
    isWechat = isWechat;
    private change:string = '0';
    private maxShowCount:number = 5;
    private loopedSlides:number = 5;
    private canshow:boolean = false;
    private categoryLists = [];//分类列表
    private commendLists = [];
    private totalCommendCount = 0;
    private showMoreBtn:boolean = true;
    private explandState = 0;//0表示展开 1表示收起
    private impressionsMap = new Map();//是否被曝光过
    private recommendtype = 0;

    private iconTypeLists = [
        '',
      require("@/assets/images/icontype/icontype1.png"),
      require("@/assets/images/icontype/icontype2.png"),
      require("@/assets/images/icontype/icontype3.png"),
      require("@/assets/images/icontype/icontype4.png"),
      require("@/assets/images/icontype/icontype5.png"),
      require("@/assets/images/icontype/icontype6.png"),
      require("@/assets/images/icontype/icontype7.png"),
      require("@/assets/images/icontype/icontype8.png"),
      require("@/assets/images/icontype/icontype9.png"),
      require("@/assets/images/icontype/icontype10.png"),
      require("@/assets/images/icontype/icontype11.png"),
      require("@/assets/images/icontype/icontype12.png"),
      require("@/assets/images/icontype/icontype13.png"),
    ];

    private mySwiperObj:any = null;

    private samllProgramData:any = {
      show:false,
      username:'',
      path:'',
      btnName:'',
    };

    initSwipe(){
        let that = this;
        this.mySwiperObj = new Swiper(".advert_lists_area", {
            loop: true,
            centeredSlides: true,
	    	slidesPerView: "auto",
            loopedSlides: this.loopedSlides,
	    	spaceBetween: 10,
	    	observer: true,
	    	observeParents: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            on:{
                slideChange: function(){
                    //@ts-ignore
                    let item:any = that.commendLists[this.realIndex];
                    if(item){
                        //如果曝光过的就不要重复曝光
                        if(!that.impressionsMap.get(item.id)){
                            AdManageApi.collectAdLog({adid:item.id,corpid:item.corpid,type:1,location:0}).then((res1:any)=>{});
                            that.impressionsMap.set(item.id,1);
                        }
                    }
                },
                slideChangeTransitionEnd: function(swiper:any){

                }
            }
		});
    }

    created() {
        this.getCategoryLists();
    }

    mounted(){
        this.getRecommendAdList();
    }

    getRecommendAdList(){
        AdManageApi.getRecommendAdList({change:this.change,maxShowCount:this.maxShowCount,recommendtype:this.recommendtype}).then((res:any)=>{
           this.commendLists = res.adRecommendLists;
           this.totalCommendCount = res.totalRecommendCount;
           if(this.totalCommendCount<=3){
            this.showMoreBtn = false;
           }
           if(this.commendLists && this.commendLists.length>0){
                this.canshow = true;
                this.$nextTick(() => {
                    this.loopedSlides = this.commendLists.length;
                    this.initSwipe();
                });
           }
            //广告加载完毕之后，进行曝光的数据记录
            //    if(this.commendLists && this.commendLists.length>0){
            //     this.commendLists.forEach((item:any)=>{
            //         AdManageApi.collectAdLog({adid:item.id,corpid:item.corpid,type:1}).then((res1:any)=>{});
            //     });
            //    }
        });
    }

    getCategoryLists(){
        AdManageApi.getCategoryLists().then((res:any)=>{
            this.categoryLists = res;
        });
    }

    //获取某个分类下的广告推荐
    getCategoryContent(category:any){
        this.$router.push({
                path:'/adCategoryContent',
                query:{
                    categoryid:category.id
                }
            }
        );
        // AdManageApi.getCategoryContent({categoryid:category.id,maxShowCount:this.maxShowCount,preview:'0',recommend:1}).then((res:any)=>{
        //     this.commendLists = res.adRecommendLists;
        //     this.totalCommendCount = res.totalRecommendCount;
        //     if(this.totalCommendCount<=3){
        //         this.showMoreBtn = false;
        //     }
        //     if(this.commendLists && this.commendLists.length>0){
        //         this.canshow = true;
        //     }
        //     //广告加载完毕之后，进行曝光的数据记录
        //     // if(this.commendLists && this.commendLists.length>0){
        //     //     this.commendLists.forEach((item:any)=>{
        //     //         AdManageApi.collectAdLog({adid:item.id,corpid:item.corpid,type:1,location:0}).then((res1:any)=>{});
        //     //     });
        //     // }
        // });
    }

    //换一批
    changeOneBatch(){
        this.change = "1";
        this.getRecommendAdList();
    }

    //获取到更多
    getMore(){
        this.maxShowCount = 9;
        this.getRecommendAdList();
        this.explandState = 1;
    }

    //收起
    downFold(){
        this.maxShowCount = 3;
        if(this.commendLists.length>3){
            this.commendLists = this.commendLists.splice(0,3);
        }
        this.explandState = 0;
    }

    /**
     * 点击的跳转的处理
     */
    gotoRecommend(item:any){
        AdManageApi.collectAdLog({adid:item.id,corpid:item.corpid,type:2,location:0}).then((res1:any)=>{
            if(item.jumptype == 2 && item.jumpurl != ""){
                this.openNewWindow(item.jumpurl);
            }else if(item.jumptype == 3 && item.jumpurl != ""){
                if(!isWechat){
                Toast("请使用微信进行打开...");
                }else{
                this.samllProgramData = {
                    show:true,
                    username:item.smallprogramid,
                    path:item.jumpurl,
                    btnName:'点击前往小程序',
                };
                }
            }
        });
    }

    /**
     * 变化处理
     */
    onSwipeChange(index:number){
        console.log("onSwipeChange index:"+index);
    }

    onCloseSmallProgram(){
      this.samllProgramData.show = false;
    }
}
